import { Link } from "react-router-dom";
import { Crosshair, Zap, Flag, Trophy } from "lucide-react";

const LOGO = "https://customer-assets-jt897jd0.emergentagent.net/job_c1e88c9c-ba91-434a-98cf-46a301cc1400/artifacts/0ga5g2nx_Gemini_Generated_Image_x16783x16783x167-removebg-preview.png";

export default function Home() {
  return (
    <div>
      {/* HERO */}
      <section className="relative overflow-hidden carbon-bg grain">
        <div className="absolute inset-0 grid-bg opacity-40" />
        <div className="scanline" />
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32 grid md:grid-cols-12 gap-8 relative">
          <div className="md:col-span-8">
            <div className="small-label text-rtrl-red mb-4 flex items-center gap-2" data-testid="hero-eyebrow">
              <Crosshair className="w-3 h-3" /> Est. 2026 · Chalmun's Spaceport Cantina
            </div>
            <h1 className="font-display uppercase text-6xl md:text-8xl leading-[0.9] tracking-wide text-white" data-testid="hero-title">
              Red Target<br />
              <span className="text-rtrl-red">Racing League</span>
            </h1>
            <p className="mt-6 max-w-2xl text-white/70 text-lg leading-relaxed">
              The premier community league for <span className="text-white">Star Wars: Galactic Racer</span>. Two disciplines. Twenty syndicates. Four rounds a night. One target — the podium.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/register" className="rtrl-btn" data-testid="hero-cta-register">
                <Flag className="w-4 h-4" /> Register as a Racer
              </Link>
              <Link to="/standings" className="rtrl-btn-ghost" data-testid="hero-cta-standings">
                <Trophy className="w-4 h-4" /> View Standings
              </Link>
              <a
                href="https://discord.com/invite/h4unWxH4G7"
                target="_blank"
                rel="noreferrer"
                className="rtrl-btn-ghost text-[#5865F2] border-[#5865F2]/40 hover:border-[#5865F2] hover:bg-[#5865F2]/10"
                data-testid="hero-cta-discord"
              >
                <svg className="w-4 h-4 fill-current" viewBox="0 0 24 24">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.03c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.03A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.072 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.873-.894a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.075.075 0 0 1 .077-.01c3.92 1.793 8.18 1.793 12.061 0a.074.075 0 0 1 .078.009a9.52 10.2 0 0 0 .373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.894a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.9 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.156-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.156 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.156-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.156 2.418z" />
                </svg>
                Join Discord
              </a>
            </div>
          </div>
          <div className="md:col-span-4 flex items-center justify-center">
            <img src={LOGO} alt="RTRL Crest" className="w-64 md:w-80 drop-shadow-[0_0_40px_rgba(229,25,25,0.4)] animate-flicker" />
          </div>
        </div>
      </section>

      {/* DISCIPLINES */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-24 grid md:grid-cols-2 gap-8">
        <div className="rtrl-card carbon-bg p-8 relative" style={{ boxShadow: "inset 0 0 60px rgba(255,107,0,0.08)" }} data-testid="discipline-pod">
          <div className="small-label text-pod flex items-center gap-2"><Zap className="w-3 h-3" /> Group A</div>
          <h3 className="font-display uppercase text-5xl mt-2 text-white">Pod Racing</h3>
          <p className="text-white/60 mt-4">Standalone class. 8-player lobbies, 4 drivers per team. Podracers race strictly against podracers.</p>
          <div className="mt-6 font-mono-tech text-pod text-3xl">MAX / 8</div>
        </div>
        <div className="rtrl-card carbon-bg p-8 relative" style={{ boxShadow: "inset 0 0 60px rgba(0,240,255,0.08)" }} data-testid="discipline-speeder">
          <div className="small-label text-speeder flex items-center gap-2"><Zap className="w-3 h-3" /> Group B</div>
          <h3 className="font-display uppercase text-5xl mt-2 text-white">Speeder Racing</h3>
          <p className="text-white/60 mt-4">Mixed-class division. Landspeeders, Speeder Bikes, Skimspeeders. 12-player lobbies, 6 drivers per team.</p>
          <div className="mt-6 font-mono-tech text-speeder text-3xl">MAX / 12</div>
        </div>
      </section>

      {/* DISCORD PROMO */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 pb-24">
        <div className="rtrl-card carbon-bg p-8 md:p-12 relative overflow-hidden border border-[#5865F2]/20 shadow-[0_0_50px_rgba(88,101,242,0.1)]">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#5865F2]/5 rounded-full blur-3xl pointer-events-none -mr-20 -mt-20"></div>
          <div className="grid md:grid-cols-12 gap-8 items-center relative z-10">
            <div className="md:col-span-8">
              <div className="small-label text-[#5865F2] mb-3 uppercase tracking-widest font-mono-tech flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#5865F2] animate-ping"></span>
                Join the Comm-Center
              </div>
              <h2 className="font-display uppercase text-4xl md:text-5xl text-white">Red Target Racing League Discord</h2>
              <p className="text-white/70 mt-4 max-w-2xl text-base md:text-lg leading-relaxed">
                Connect with fellow pilots, coordinate practice lobbies, schedule your custom matches, post your clips, and receive live broadcast announcements directly on our official Discord server.
              </p>
            </div>
            <div className="md:col-span-4 flex md:justify-end">
              <a
                href="https://discord.com/invite/h4unWxH4G7"
                target="_blank"
                rel="noreferrer"
                className="rtrl-btn w-full md:w-auto justify-center bg-[#5865F2] hover:bg-[#4752C4] text-white flex items-center gap-3 px-8 py-4 uppercase font-bold tracking-wider text-base"
              >
                <svg className="w-6 h-6 fill-current" viewBox="0 0 24 24">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.03c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.03A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.072 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.873-.894a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.075.075 0 0 1 .077-.01c3.92 1.793 8.18 1.793 12.061 0a.074.075 0 0 1 .078.009a9.52 10.2 0 0 0 .373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.894a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.9 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.156-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.156 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.156-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.156 2.418z" />
                </svg>
                Connect Now
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* STORY */}
      <section className="carbon-bg border-y border-surface-line">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-24 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="small-label text-rtrl-red">Our League</div>
            <h2 className="font-display uppercase text-5xl md:text-6xl mt-2 text-white">Positive.<br />Competitive.<br />Volunteer-run.</h2>
          </div>
          <div className="md:col-span-7 text-white/70 leading-relaxed text-lg space-y-4">
            <p>RTRL was founded to provide a positive, good-sportsmanship environment where drivers can compete against one another in an organized league format.</p>
            <p>We bring decades of experience running gaming communities across sports leagues and MMO guilds. This is a <span className="text-white">fully volunteer operation</span> — please have patience with our league staff as we build this out.</p>
            <p className="text-rtrl-red font-body uppercase tracking-widest">Happy Racing Days.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
